<template>
    <div>
        <span>
            <b-button
                class="align-baseline mr-1"
                title="Show Subcategories"
                variant="default"
                @click="showSubCategoryModal"
            >
                <font-awesome-icon :icon="['fas', 'bars']"></font-awesome-icon>
            </b-button>
            <b-button class="align-baseline mr-1" title="Edit" variant="default" @click="showEditModal">
                <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
            </b-button>
            <b-button class="align-baseline" title="Delete" variant="default" @click="showDeleteModal">
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
            </b-button>
        </span>
        <modal :id="deleteModalId" title="Delete Category" ok-title="Confirm" @ok="deleteCategory">
            Category "{{ params.data.name }}" will be deleted. Are you sure?
        </modal>
        <validation-observer ref="edit_category_form" v-slot="{ meta, setValues }">
            <modal
                ok-title="Save"
                :id="editModalId"
                title="Edit Category"
                @ok.prevent="editCategory"
                :ok-disabled="!meta.valid"
                @shown="setValues({ name: params.data.name })"
            >
                <validation-provider name="name" v-slot="{ errors, handleChange }" rules="required">
                    <form-input
                        :floating-label="labelName"
                        v-model="categoryName"
                        :error="errors[0]"
                        @input="handleChange"
                    ></form-input>
                </validation-provider>
            </modal>
        </validation-observer>
        <modal
            :id="subCategoryId"
            :title="params.data.name + ' Subcategories'"
            ok-title="Close"
            :ok-only="true"
            body-class="subcategories-modal"
            content-class="subcategories-modal-content"
        >
            <sub-category-list :categoryId="categoryId" />
        </modal>
    </div>
</template>

<script>
    import Modal from '../../generic/modal/modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import SubCategoryList from './property-subcategories-list.vue';
    import API from '../../../api';
    import { PROPERTY_CATEGORIES_UPDATE_DELETE_ENDPOINT } from '../../../endpoints';

    export default {
        components: {
            Modal,
            FormInput,
            SubCategoryList,
        },
        data() {
            return {
                categoryName: null,
                labelName: 'Category name',
                categoryId: null,
            };
        },
        computed: {
            editModalId() {
                return 'edit-modal' + this.params.data.id;
            },
            deleteModalId() {
                return 'delete-modal' + this.params.data.id;
            },
            subCategoryId() {
                return 'sub-category-modal' + this.params.data.id;
            },
        },
        created() {
            this.categoryName = this.params.data.name;
            this.categoryId = this.params.data.id;
        },

        methods: {
            async fetchSubCategories() {
                try {
                    const { data } = await API.get(PROPERTY_SUBCATEGORY_ENDPOINT(this.params.data.id));
                    this.items = data;
                } catch (e) {
                    this.errorToast({ text: 'Could not load subcategories' });
                }
            },
            showDeleteModal() {
                this.$bvModal.show(this.deleteModalId);
            },
            showSubCategoryModal() {
                this.$bvModal.show(this.subCategoryId);
            },
            showEditModal() {
                this.categoryName = this.params.data.name;
                this.$bvModal.show(this.editModalId);
            },
            async deleteCategory() {
                try {
                    await API.delete(PROPERTY_CATEGORIES_UPDATE_DELETE_ENDPOINT(this.params.data.id));
                    await this.params.update();
                } catch (e) {
                    this.errorToast({
                        text: e.response?.data.detail || 'Could not delete category',
                    });
                }
            },
            async editCategory() {
                try {
                    await API.put(PROPERTY_CATEGORIES_UPDATE_DELETE_ENDPOINT(this.params.data.id), {
                        name: this.categoryName,
                        labelName: this.labelName,
                    });
                    await this.params.update();
                    this.$bvModal.hide(this.editModalId);
                } catch (e) {
                    this.errorToast({ text: 'Could not update subcategory' });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>

<style lang="scss">
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .subcategories-modal-content {
        width: 600px !important;
        height: 600px;
        .subcategories-modal {
            .lx-grid {
                height: 390px !important;
            }
        }
    }

    @include media-breakpoint-down(sm) {
        .subcategories-modal-content {
            max-width: 100% !important;
        }
    }
</style>
